module.exports = __webpack_public_path__ + "img/Lag-SM-thumnail.d2a4925b.jpg";